import { gql } from '@apollo/client';

export const TelnyxQuery = gql`
  query TelnyxSearch(
    $city: String
    $region: String
    $startsWith: String
    $areaCode: String
    $limit: Int
  ) {
    telnyxSearchPhones(
      region: $region
      city: $city
      startsWith: $startsWith
      areaCode: $areaCode
      limit: $limit
    ) {
      monthlyCost
      oneTimeCost
      phoneNumber
      location
    }
  }
`;

export const ProvisionTelnyxMutation = gql`
  mutation ProvisionTelnyx($provisionTelnyx: ProvisionVendorInput!) {
    provisionTelnyx(provisionTelnyx: $provisionTelnyx)
  }
`;
